import { css } from "@emotion/react";

import { colors } from "./colors";
import { medias } from "./medias";
import { mixins } from "./mixins";
import { typography } from "./typography";

const theme = {
  name: "Default",
  colors,
  medias,
  mixins,
  typography,
  structures: {
    Page: css`
      background: ${colors.grayBg};

      display: flex;
      flex-direction: column;
      align-items: stretch;

      padding-bottom: 63px;

      @media ${medias.desktop} {
        padding: 0;
      }
    `,
  },
  zIndexes: {
    modal: 100,
  },
};

export { theme };
